import { useUpdateClient } from 'app/features/profile/accountInfo/editAccountInfo';
import { CustomButton } from 'Components/Auth/CustomButton';
import { PhoneNumInput } from 'Components/Auth/PhoneInput';
import { SelectInput } from 'Components/Auth/SelectInput';
import { TextInput } from 'Components/Auth/TextInput';
import Form from 'Components/Form';
import DateInput from 'Components/Form/DateInput';
import { MaskedInput } from 'Components/Form/MaskedInput';
import { errorToast, successToast } from 'Components/Notifications';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import * as Yup from 'yup';
import { ProfileUser } from '../../editPersonalDetails';

export interface ISpouseStepStepProps {}
export type FormInputs = {
  tax_filing_status: string;
  firstname: string;
  lastname: string;
  ssn: string;
  birth_date: string;
  email: string;
  occupation: string;
  phone_number: string;
};

export const validationSchema = Yup.object().shape({
  tax_filing_status: Yup.string().trim().required('required'),
  firstname: Yup.string().trim(),
  lastname: Yup.string().trim(),
  ssn: Yup.string().trim(),
  birth_date: Yup.string().trim().nullable(),
  email: Yup.string().email(),
  occupation: Yup.string().trim(),
  phone_number: Yup.string().trim(),
});
export const TaxFilingStatusOptions = [
  { label: 'Single', value: 'Single' },
  { label: 'Married Filing Jointly', value: 'Married Filing Jointly' },
  { label: 'Married Filing Separately', value: 'Married Filing Separately' },
  { label: 'Head of Household', value: 'Head of Household' },
  { label: 'Qualifying Widower', value: 'Qualifying Widower' },
];

export default function SpouseStep(props: ISpouseStepStepProps) {
  const { UpdateClient, client } = useUpdateClient();

  const [haveSpouse, setHaveSpouse] = useState(String);

  let initialData: FormInputs = {
    tax_filing_status: client?.tax_filing_status || '',
    firstname: client?.spouse?.firstname || '',
    lastname: client?.spouse?.lastname || '',
    ssn: client?.spouse?.ssn || '',
    birth_date: client?.spouse?.birth_date || '',
    email: client?.spouse?.email || '',
    occupation: client?.spouse?.occupation || '',
    phone_number: client?.spouse?.phone_number || '',
  };
  let { setActiveStep } = React.useContext(ProfileUser);
  useEffect(() => {
    setHaveSpouse(client?.tax_filing_status || '');
  }, []);

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    let check =
      data.birth_date === '' &&
      data.email === '' &&
      data.firstname === '' &&
      data.lastname === '' &&
      data.occupation === '' &&
      data.phone_number === '' &&
      data.ssn === '';
    const deleteSpouse = { _destroy: true };

    check = !(
      haveSpouse === 'Married Filing Separately' ||
      haveSpouse === 'Married Filing Jointly'
    );

    try {
      await UpdateClient({
        tax_filing_status: data?.tax_filing_status,
        spouse_attributes: check ? deleteSpouse : data,
      }).then(async () => {
        await successToast('Spouse Information Updated Successfully');
        setActiveStep('Dependent');
      });
    } catch (error: any) {
      errorToast(error);
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      defaultValues={initialData}
      validationSchema={validationSchema}
    >
      {(methods) => (
        <>
          <div className="flex w-full mb-3">
            <div className="w-1/3 md-max:w-full">
              <SelectInput
                name="tax_filing_status"
                label="What's your tax filing status?"
                options={TaxFilingStatusOptions}
                rules={{ required: 'required' }}
                type="select"
                placeholder="Select Your Tax Filing Status"
                setSelectedValue={setHaveSpouse}
              />
            </div>
          </div>

          {setHaveSpouse(methods.getValues('tax_filing_status'))}

          {(methods.getValues('tax_filing_status') ===
            'Married Filing Separately' ||
            methods.getValues('tax_filing_status') ===
              'Married Filing Jointly') && (
            <>
              <div className="flex w-full mb-3 gap-4 md-max:grid ">
                <div className="w-1/6 md-max:w-full">
                  <TextInput
                    name="firstname"
                    label="Spouse's First Name"
                    placeholder="Spouse's First Name"
                    type="text"
                  />
                </div>
                <div className="w-1/6 md-max:w-full">
                  <TextInput
                    name="lastname"
                    label="Spouse's Last Name"
                    placeholder="Spouse's Last Name"
                    type="text"
                  />
                </div>
              </div>
              <div className="flex w-full mb-3 ">
                <div className="w-1/3 md-max:w-full">
                  <MaskedInput
                    name="ssn"
                    label="Spouse's Social Security Number"
                    mask="999-99-9999"
                    type="maskedInput"
                    placeholder="Spouse's SSN"
                  />
                </div>
              </div>
              <div className="flex w-full mb-3">
                <div className="w-1/3 md-max:w-full">
                  <DateInput
                    name="birth_date"
                    type={'date'}
                    placeholder={'mm/dd/yyyy'}
                    label="Spouse's Date of Birth"
                  />
                </div>
              </div>
              <div className="flex w-full mb-3">
                <div className="w-1/3 md-max:w-full">
                  <TextInput
                    name="email"
                    label="Spouse's Email"
                    placeholder="Spouse's Email"
                    type="text"
                  />
                </div>
              </div>

              <div className="flex w-full mb-3">
                <div className="w-1/3 md-max:w-full">
                  <PhoneNumInput
                    name="phone_number"
                    label="Spouse's Phone Number"
                  />
                </div>
              </div>
              <div className="flex w-full mb-3">
                <div className="w-1/3 md-max:w-full">
                  <TextInput
                    name="occupation"
                    label="Spouse's Occupation"
                    placeholder="Spouse's Occupation"
                    type="text"
                  />
                </div>
              </div>
            </>
          )}

          <div className="w-1/6 flex flex-inline gap-4 mt-6 md-max:w-full">
            <CustomButton type="submit" text="Save & Continue" />
          </div>
        </>
      )}
    </Form>
  );
}
